import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Anmol Kumar</span>{" "}
            from <span className="purple">Bihar, India</span>.
            <br />
            I’m currently working as a{" "}
            <span className="purple">Solution Engineer</span> at{" "}
            <span className="purple">Accuknox</span>.
            <br />I completed my Bachelor of Technology  in{" "}
            <span className="purple">Computer Science and Technology</span> from{" "}
            <span className="purple">Lovely Professional University</span>.
            <br />
            <br />
            Outside of my daily engineering work, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Bridging the gap between complex problems and elegant solutions"{" "}
          </p>
          <footer className="blockquote-footer">Anmol</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
